<app-user-public-profile-sites-visited *ngIf="employeeService?.employee?.hash" [hash]="employeeService?.employee?.hash" [includeAdminActions]="true" [canView]="canView"></app-user-public-profile-sites-visited>
